import React, {Component} from 'react'
import FJLocalStore from '../../../store/FJLocalStore'
import {connect} from "react-redux";
import FJExportIntro from '../view/FJExportIntro'
import FJMessageStore from "../../../store/FJMessageStore";
import FJElementStore from "../../../store/FJElementStore";
import FJIntros from "../view/FJIntros";
import FJConfig from "../../../config/FJConfig";
import FJRatioStore from "../../../store/FJRatioStore";
import {FJExportVideoAction, FJUserAction} from "../../../redux/action/FJRoot.action";
import FJCanvasStore from "../../../store/FJCanvasStore";
import key from 'keymaster'
import FJExportPreviewAction from "../../../redux/action/FJExportPreview.action";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJExportPreviewContainer from "./FJExportPreviewContainer";

class FJExportIntroContainer extends Component {

  constructor(props) {
    super(props);
    this._changeIntroTimer = null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (this.props.isShow !== prevProps.isShow) {
      if (this.props.isShow) {
        this._bindView();
        this._initIntro();
        this.props.setPreviewVolume(this.props.volume);
        key.setScope('exportPreview');
      } else {
        this.props.togglePlayPreview(false);
        key.setScope('');
      }
    }
  }

  _bindView = () => {
    const view = this._preview.getView();
    const {UPDATE_CANVAS_SIZE, BIND_EXPORT_PREVIEW} = FJCanvasStore.command;
    const {width, height} = view.getBoundingClientRect();
    FJCanvasStore.executeSync(BIND_EXPORT_PREVIEW, view);
    FJCanvasStore.execute(UPDATE_CANVAS_SIZE, {width, height}).catch(e => console.log(e));
  };

  _retryIntro = () => {
    this._changeIntro(this.props.intro);
  };

  _onUserChangeIntro = (intro) => {
    this.props.updateUserChangedIntro();
    this._changeIntro(intro);
  };

  _changeIntro = (intro) => {
    const {togglePlayPreview, seekPreview, changeIntro} = this.props;
    togglePlayPreview(false);
    seekPreview('start', 0);
    seekPreview('change', 0);
    seekPreview('end', 0);
    changeIntro(intro, this._preview.getPreviewSize(), () => {
      togglePlayPreview(true);
    });
  };

  _calcList = () => {
    const {overLimitContents} = this.props;
    const introList = FJElementStore.getList().intro;
    const list = overLimitContents.length === 0 ? [...introList] : [...introList].slice(1);
    const {elementVideoPath, elementIconPath, version} = FJConfig;
    list.forEach(item => {
      const {thumbnail, url, name} = item;
      const transName = name.replace(/\s+/g, '_');
      if (!thumbnail) {
        item.thumbnail = `${elementIconPath}${transName}.svg?v=${version}`;
      }
      if (name !== 'NO_INTRO' && !url) {
        item.url = `${elementVideoPath}${transName}.mp4?v=${version}`;
      }
    });
    return list;
  };

  _updateCanvasSize = (width, height) => {
    if (this.props.isShow) {
      let {UPDATE_CANVAS_SIZE} = FJCanvasStore.command;
      FJCanvasStore.execute(UPDATE_CANVAS_SIZE, {width, height}).then(() => {
        this._retryIntro();
      })
    }
  };

  _renderPreview = (props) => {
    const {containerSize, previewSize} = props;
    const {introStatus} = this.props;
    return (
      <FJExportPreviewContainer width={containerSize.width}
                                height={containerSize.height}
                                previewWidth={previewSize.width}
                                previewHeight={previewSize.height}
                                ref={ele => {
                                  this._preview = ele
                                }}
                                onRetry={this._retryIntro}
                                introStatus={introStatus}
                                onUpdateCanvasSize={this._updateCanvasSize}
      />
    );
  };

  _initIntro = () => {
    let {overLimitContents, paymentLevel, intro, userChangedIntro} = this.props;
    let introList = this._calcList();
    let initIntro = 'NO_INTRO';
    if (overLimitContents.length === 0) {
      if (userChangedIntro) {
        initIntro = intro;
      } else {
        initIntro = paymentLevel === FJViewConstant.USER_PAYMENT_FREE ? introList[1].name : 'NO_INTRO';
      }
    } else {
      if (userChangedIntro) {
        initIntro = intro === 'NO_INTRO' ? introList[0].name : intro;
      } else {
        initIntro = introList[0].name;
      }
    }

    // 初次进入时为了获取正确的size故而加入异步
    // 加入异步后避免界面数据异常所以提前更新status及intro
    this.props.updateIntroStatus('loading');
    this.props.updateIntro(initIntro);

    // 加入延迟是因为预览区域的尺寸更新可能不及时
    // 导致intro渲染异常
    setTimeout(() => {
      this._changeIntro(initIntro);
    }, 150);
  };

  _renderIntros = (props) => {
    const {style} = props;
    const {intro, userName, videoName} = this.props;
    const {onRenderPrimaryButton} = this.props;
    let inputPaddingLeft = 126;
    if (FJLocalStore.curTag() === 'es') {
      inputPaddingLeft += 50;
    }
    let list = this._calcList();
    return (
      <FJIntros style={style}
                inputPaddingLeft={inputPaddingLeft}
                videoName={videoName}
                videoNamePlaceholder={FJLocalStore._('enter-video-name')}
                videoNameTitle={FJLocalStore._('video-name')}
                videoNameErrorText={FJLocalStore._('enter-video-name')}
                userNamePlaceholder={FJLocalStore._('enter-editor-name')}
                userNameTitle={FJLocalStore._('create-by')}
                userName={userName}
                infoTitle={FJLocalStore._('set-intro-title')}
                introTitle={FJLocalStore._('flexclip-intro')}
                backText={FJLocalStore._('back')}
                exportBtnText={FJLocalStore._('export-video')}
                intros={list}
                selectedIntroName={intro}
                onExport={this._export}
                onIntroChange={this._onUserChangeIntro}
                onVideoNameChange={this._changeVideoName}
                onVideoNameSubmit={this._submitVideoName}
                onUserNameChange={this._changeUserName}
                onUserNameSubmit={this._submitUserName}
                onRenderPrimaryButton={onRenderPrimaryButton}

      />
    );
  };

  _replay = () => {
    const {togglePlayPreview, seekPreview, updateIntroDataCore} = this.props;
    updateIntroDataCore();
    seekPreview('start', 0);
    seekPreview('change', 0);
    seekPreview('end', 0);
    togglePlayPreview(true);
  };

  _changeUserName = (value) => {
    const {changeEditor} = this.props;
    changeEditor(value);
    this._hasChangeUserName = true;
  };

  _submitUserName = (value) => {
    const {changeEditor} = this.props;
    changeEditor(value, {
      done: () => {
        if (this._hasChangeUserName && this.props.isShow) {
          this._replay();
        }
        this._hasChangeUserName = false;
      }, isSubmit: true
    });
  };

  _changeVideoName = (value) => {
    const {changeExportName} = this.props;
    changeExportName(value);
    this._hasChangeVideoName = true;
  };

  _submitVideoName = (value) => {
    const {changeExportName} = this.props;
    changeExportName(value, {
      done: () => {
        if (this._hasChangeVideoName && this.props.isShow) {
          this._replay();
        }
        this._hasChangeVideoName = false;
      }, isSubmit: true
    });
  };

  _export = () => {
    let {introStatus, qualitySelected, ratioType} = this.props;
    let {onExport} = this.props;
    if (introStatus === 'loading') {
      FJMessageStore.addMessage(FJLocalStore._('export-before-loading'), 'warning')
    } else if (introStatus === 'error') {
      FJMessageStore.addMessage(FJLocalStore._('export-before-error'), 'warning')
    } else {
      let size = {};
      switch (qualitySelected) {
        case FJViewConstant.RESOLUTION_480P:
          size.height = 480;
          break;
        case FJViewConstant.RESOLUTION_720P:
          if (ratioType === FJRatioStore.allRatioType().vertical) {
            size.width = 720;
          } else {
            size.height = 720;
          }
          break;
        case FJViewConstant.RESOLUTION_1080P:
          size.height = 1080;
          break;
      }
      onExport(size);
    }
  };

  render() {
    const {intro, isShow, ratioType} = this.props;
    const {onBack} = this.props;
    const ratioSize = FJRatioStore.ratioSizeWithRatioType(ratioType);
    return (
      <FJExportIntro isShow={isShow}
                     onBack={onBack}
                     ref={ele => {
                       this._exportIntro = ele
                     }}
                     backText={FJLocalStore._('back')}
                     ratioSize={ratioSize}
                     introName={intro}
                     onRenderPreview={this._renderPreview}
                     onRenderIntros={this._renderIntros}
                     onIntroChange={this._onUserChangeIntro}
      />
    );
  }

}

const mapStateToProps = (state) => {
  return {
    intro: state.intro.intro,
    introList: state.intro.introList,
    introStatus: state.intro.introStatus,
    userChangedIntro: state.intro.userChangedIntro,
    overLimitContents: state.payment.overLimitContents,
    paymentLevel: state.payment.paymentLevel,
    qualitySelected: state.exportVideo.qualitySelected,
    ratioType: state.more.ratioType,
    userName: state.user.videoEditor,
    videoName: state.intro.videoName,
    volume: state.exportPreview.volume,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateIntroDataCore: function () {
      dispatch(FJExportVideoAction.updateIntroDataCoreAction());
    },
    updateIntroStatus: function () {
      dispatch(FJExportVideoAction.updateIntroStatusAction('loading'));
    },
    updateIntro: function (name) {
      dispatch(FJExportVideoAction.updateIntroAction(name));
    },
    updateUserChangedIntro: function () {
      dispatch(FJExportVideoAction.updateUserChangedIntroAction());
    },
    changeIntro: function (intro, viewSize, done) {
      dispatch(FJExportVideoAction.changeIntroAction(intro, viewSize, done));
    },
    changeExportName: function (name, options) {
      dispatch(FJUserAction.changeExportNameAction(name, options));
    },
    changeEditor: function (name, options) {
      dispatch(FJUserAction.changeEditorNameAction(name, options));
    },
    togglePlayPreview: function (toggle) {
      dispatch(FJExportPreviewAction.toggleExportPreviewPlayAction(toggle))
    },
    seekPreview: function (type, progress) {
      dispatch(FJExportPreviewAction.seekExportPreviewAction(type, progress));
    },
    setPreviewVolume: function (volume) {
      dispatch(FJExportPreviewAction.setGlobalVolumeAction(volume, {useCache: true}));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJExportIntroContainer)
